/** 福利中心 - 逻辑数据 */
let WelfareCenterLogic = xClass("WelfareCenterLogic");
const STORAGE_KEY = "welfare_center_show";
const STORAGE_FLAG_KEY = "welfare_center_flag";

WelfareCenterLogic.config = null;
WelfareCenterLogic.onEvent = false;
/** 活动数据 */
WelfareCenterLogic.info = [];
/** 已经展示过的活动id */
WelfareCenterLogic.showActivityIds = [];
/** 活动对应flag */
WelfareCenterLogic.ativityFlag = [];

WelfareCenterLogic.eventActions = [];
WelfareCenterLogic.eventPanels = [];

WelfareCenterLogic.enterType = null

/** 初始化福利中心事件监听、showActivity */
WelfareCenterLogic.onGlobalEvent = function () {
    if (!WelfareCenterLogic.onEvent) {
        GlobalEventDispatcher.getInstance().addEventListener(
            kGlobalEvents.kWelfareCenterAction,
            function (event) {
                // {
                //     id: number,
                //     redDot: boolean,
                //     countDown:number,
                //     type:string,
                //     flag:number / string
                // }
                event.data["名称"] = WelfareCenterLogic.ids[event.data.id];
                console.log("福利中心事件 活动数据：" + JSON.stringify(event.data));

                if (!WelfareCenterLogic.config) {
                    console.log("福利中心事件 接收暂不处理");
                    WelfareCenterLogic.eventActions.push(event);
                    return;
                }
                WelfareCenterLogic.update(event.data);
            }
        );

        GlobalEventDispatcher.getInstance().addEventListener(
            kGlobalEvents.kWelfareCenterPanel,
            function (event) {

                event.data["名称"] = WelfareCenterLogic.ids[event.data.id];
                console.log("福利中心事件 面板打开：" + JSON.stringify(event.data));

                if (!WelfareCenterLogic.config) {
                    console.log("福利中心事件 接收暂不处理");
                    WelfareCenterLogic.eventPanels.push(event);
                    return;
                }
                //如果面板打开事件比icon数据早发出且活动数据带有flag，需要面板也加上对应的flag
                //否则banner会出现“！”
                WelfareCenterLogic.addNewActivity(event.data);
                //
                if (WelfareCenterLogic.mianPanel) {
                    WelfareCenterLogic.mianPanel.refreshTab();
                }
                let welfareCenterBtn = WelfareCenterLogic.getSceneIcon();
                if (welfareCenterBtn) {
                    welfareCenterBtn.updateDot();
                }
            }
        );
        //
        WelfareCenterLogic.loadConfig().then(function () {
            console.log("福利中心 config加载完毕");
            WelfareCenterLogic.initActivityFlag();
            WelfareCenterLogic.initNewActivity();
            //
            let eventActions = WelfareCenterLogic.eventActions;
            for (let i = 0; i < eventActions.length; i++) {
                WelfareCenterLogic.update(eventActions[i].data);
            }
            WelfareCenterLogic.eventActions = [];
            //
            let eventPanels = WelfareCenterLogic.eventPanels;
            for (let i = 0; i < eventPanels.length; i++) {
                WelfareCenterLogic.addNewActivity(eventPanels[i].data);
            }
            WelfareCenterLogic.eventPanels = [];
        });

        WelfareCenterLogic.onEvent = true;
    }
}

/** 增删改 活动数据 */
WelfareCenterLogic.update = function (data) {
    if (data.id) {
        //
        if (data.flag) {
            let flag = WelfareCenterLogic.getActivityFlag(data.id);
            if (!flag || flag != data.flag) {
                WelfareCenterLogic.setActivityFlag(data);
                WelfareCenterLogic.delNewActivity(data.id);
            }
        }
        //
        let isUpdate = false;
        let info = WelfareCenterLogic.info;
        for (let i = 0; i < info.length; i++) {
            let temp = info[i];
            if (temp && temp.id == data.id) {
                if (data.type == "del") {
                    info.splice(i, 1);
                    WelfareCenterLogic.delNewActivity(temp.id);
                    if (WelfareCenterLogic.mianPanel) {
                        WelfareCenterLogic.mianPanel.onChangeItem(data);
                    }
                } else {
                    info[i] = data;
                    if (WelfareCenterLogic.mianPanel) {
                        WelfareCenterLogic.mianPanel.refreshTab();
                    }
                }
                isUpdate = true;
                break;
            }
        }
        //
        if (data.type && data.type == "del") {
            isUpdate = true;
        }
        if (!isUpdate) {
            info.push(data);
            if (WelfareCenterLogic.mianPanel) {
                WelfareCenterLogic.mianPanel.onChangeItem(data);
            }
        }

        let welfareCenterBtn = WelfareCenterLogic.getSceneIcon();
        if (welfareCenterBtn) {
            welfareCenterBtn.updateDot();
        }
    }
}

/** 是否显示红点 */
WelfareCenterLogic.isRedDot = function () {
    let info = WelfareCenterLogic.info;
    const config = WelfareCenterLogic.config;
    for (let i = 0; i < info.length; i++) {
        let temp = info[i];
        if (temp.redDot && config[temp.id] && config[temp.id].show) {
            return true;
        }
    }
    return false;
}

/** 获取当前可展示的banner */
WelfareCenterLogic.getActivityByType = function (type) {
    let arr = [];
    let info = WelfareCenterLogic.info;
    const config = WelfareCenterLogic.config;
    for (let i = 0; i < info.length; i++) {
        let temp = info[i];
        if (config[temp.id] && config[temp.id].show && config[temp.id].type == type) {
            //
            let data = JSON.parse(JSON.stringify(config[temp.id]));
            data.redDot = temp.redDot || false;
            data.countDown = temp.countDown || 0;
            arr.push(data);
        }
    }
    arr.sort((a, b) => {
        return a.sort - b.sort;
    })
    return arr;
}

// /**所有子活动初始化完成后调用,如果不是最后执行，会多出 ！提示 */
WelfareCenterLogic.updateNewActivity = function () {
    console.log("福利中心 - 开始初始化数据");
    const config = WelfareCenterLogic.config;
    let showActivityIds = WelfareCenterLogic.showActivityIds;
    //删除以前点击过，但是本次未开放的活动，便于下次新一轮活动展示 ！
    let info = WelfareCenterLogic.info;
    let arr = [];
    for (let i = 0; i < info.length; i++) {
        let temp = info[i];
        if (config[temp.id] && config[temp.id].show) {
            arr.push(temp.id);
        }
    }

    for (let i = 1; i < showActivityIds.length; i++) {
        if (arr.indexOf(showActivityIds[i]) == -1 && config[showActivityIds[i]] && config[showActivityIds[i]].isNew) {
            showActivityIds.splice(i, 1);
            i--;
        }
    }
    cc.UserDefault.getInstance().setStringForKey(STORAGE_KEY, JSON.stringify(showActivityIds));
    console.log("福利中心 - 数据: " + showActivityIds);
}

WelfareCenterLogic.initNewActivity = function () {
    const config = WelfareCenterLogic.config;
    //初始化已经展示过的活动id 
    let showActivityIds = WelfareCenterLogic.showActivityIds;
    if (!showActivityIds.length) {
        let str = cc.UserDefault.getInstance().getStringForKey(STORAGE_KEY);
        if (str) {
            let temp = JSON.parse(str);
            showActivityIds = temp;
        }
        for (let key in config) {
            let cfg = config[key];
            if (cfg && !cfg.isNew && showActivityIds.indexOf(cfg.id) == -1) {
                showActivityIds.push(cfg.id);
            }
        }
        WelfareCenterLogic.showActivityIds = showActivityIds;
        cc.UserDefault.getInstance().setStringForKey(STORAGE_KEY, JSON.stringify(WelfareCenterLogic.showActivityIds));
    }
    console.log("福利中心 - 加载本地数据: " + showActivityIds);
}

/** 是否显示 ！ */
WelfareCenterLogic.hasNewActivity = function () {
    const info = WelfareCenterLogic.info;
    const config = WelfareCenterLogic.config;
    for (let i = 0; i < info.length; i++) {
        let temp = info[i];
        if (config[temp.id] && config[temp.id].show
            && WelfareCenterLogic.showActivityIds.indexOf(info[i].id) == -1) {
            return true;
        }
    }
    return false;
}

WelfareCenterLogic.delNewActivity = function (id) {
    let showActivityIds = WelfareCenterLogic.showActivityIds;
    const config = WelfareCenterLogic.config;
    const index = showActivityIds.indexOf(id);
    if (config[id].isNew && index != -1) {
        WelfareCenterLogic.showActivityIds.splice(index, 1);
        cc.UserDefault.getInstance().setStringForKey(STORAGE_KEY, JSON.stringify(showActivityIds));
        console.log("福利中心 - 数据: " + showActivityIds);
    }
}

WelfareCenterLogic.addNewActivity = function (data) {
    const id = data.id;
    let showActivityIds = WelfareCenterLogic.showActivityIds;
    if (showActivityIds.indexOf(id) == -1) {
        showActivityIds.push(id);
        cc.UserDefault.getInstance().setStringForKey(STORAGE_KEY, JSON.stringify(showActivityIds));

        WelfareCenterLogic.setActivityFlag(data);
        console.log("福利中心 - 数据: " + showActivityIds);
    }
}

WelfareCenterLogic.initActivityFlag = function () {
    let arr = [];
    let str = cc.UserDefault.getInstance().getStringForKey(STORAGE_FLAG_KEY);
    if (str) {
        arr = JSON.parse(str);
    } else {
        cc.UserDefault.getInstance().setStringForKey(STORAGE_FLAG_KEY, JSON.stringify(arr));
    }
    WelfareCenterLogic.ativityFlag = arr;
    console.log("福利中心 - 加载本地数据: " + JSON.stringify(arr));
}

WelfareCenterLogic.getActivityFlag = function (id) {
    for (let i = 0; i < WelfareCenterLogic.ativityFlag.length; i++) {
        const temp = WelfareCenterLogic.ativityFlag[i];
        if (temp.id == id && temp.flag) {
            return temp.flag;
        }
    }
    return null;
}

WelfareCenterLogic.setActivityFlag = function (data) {
    if (!data.flag) return;
    let isUpdate = false;
    for (let i = 0; i < WelfareCenterLogic.ativityFlag.length; i++) {
        const temp = WelfareCenterLogic.ativityFlag[i];
        if (temp.id == data.id) {
            temp.flag = data.flag;
            isUpdate = true;
            break;
        }
    }

    if (!isUpdate) {
        WelfareCenterLogic.ativityFlag.push({
            id: data.id,
            flag: data.flag,
        })
    }

    cc.UserDefault.getInstance().setStringForKey(STORAGE_FLAG_KEY, JSON.stringify(WelfareCenterLogic.ativityFlag));
}

/** 打开面板 -  */
WelfareCenterLogic.openPanel = function (cb, cbClose) {
    const WelfareCenterPanel = require("./WelfareCenterPanel");
    function onResLoad() {
        let panel = WelfareCenterPanel.create();
        panel.popup(true, null, null, 1);
        panel.on(BasePanelEvent.Close, function () {
            cbClose && cbClose();
        });
        cb && cb(panel);
        WelfareCenterLogic.mianPanel = panel;
    }

    function onResLoadFail(evt) {
        cc.log("[WelfareCenterPanel Package]", "unable to create WelfareCenterPanel. load res failed.", evt);
        cb && cb();
    }
    WelfareCenterPanel.preloadRes(onResLoad, onResLoadFail, onResLoadFail, true);
}

WelfareCenterLogic.closePanel = function () {
    if (WelfareCenterLogic.mianPanel) {
        WelfareCenterLogic.mianPanel.onClose();
    }
    WelfareCenterLogic.mianPanel = null;
}

/** 获取大厅中的功能icon，用来销毁和刷新红点 */
WelfareCenterLogic.getSceneIcon = function () {
    let btnLayer = require("clover/scene/HomeScene").getInstance().btnLayer;
    if (btnLayer.WelfareCenterBtn) {
        return btnLayer.WelfareCenterBtn;
    }
    return null;
}


/** 加载配置项 */
WelfareCenterLogic.loadConfig = function () {
    if (!WelfareCenterLogic.config) {
        return new Promise((resolve, reject) => {
            CfgManager.load("welfare_center_config").then(() => {
                WelfareCenterLogic.config = CfgManager.get("welfare_center_config");
                resolve();
                CfgManager.release("welfare_center_config");
            }).catch(() => reject())
        }
        );
    } else {
        return Promise.resolve();
    }
}


//////////////////////////////////打点///////////////////////////////////////
WelfareCenterLogic.dcSimple = function (subCategory, params = {}, category) {
    if (!params.session) {
        params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    }
    DCAssist.userTrack(category ? category : ModuleName.WELFARE_CENTER, subCategory, params);
    return params;
}
/** 主页面曝光时的session、pf、type */
WelfareCenterLogic.dcInfo = {};

WelfareCenterLogic.activityName = {
    1: "newchest",
    2: "redbag",
    3: "interactive",
    4: "wx_shop_video_ad",
    5: "ad_gacha",
    6: "monthly_card",
    7: "battle_pass",
    8: "secret_shop",
    9: "ai_package",
    10: "endless_treasure",
    11: "island_treasure",
    12: "limit_package",
    13: "tetris",
    14: "ad_free_ticket",
    15: "PVP",
    99: "empty",
}

WelfareCenterLogic.ids = ["",
    "星星幸运礼", "免费精力", "免费礼物", "免费风车币", "金币转转转",
    "月卡", "通行证", "神秘商店", "ai礼包", "无尽宝藏",
    "海岛礼包", "限定礼包", "俄罗斯方块", "特权买就送", "友谊赛"];

module.exports = WelfareCenterLogic;